import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface Props {
  children: ReactNode;
  hasError?: boolean;
  highlighted?: boolean;
  onHover?: () => void;
  onHoverLeave?: () => void;
  errorMessage?: string;
  warningMessage?: string;
  className?: string;
}

export const BulkEditableCell = ({
  children,
  hasError,
  highlighted,
  onHover,
  onHoverLeave,
  errorMessage,
  warningMessage,
  className,
}: Props) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <div
      className={cn(
        "rounded-md",
        hasError && "ring-destructive ring-2",
        !hasError && highlighted && "bg-primary/10 ring-primary ring-2",
      )}
      onMouseEnter={onHover}
      onMouseLeave={onHoverLeave}
    >
      {children}
    </div>
    {errorMessage && <p className="text-destructive text-xs">{errorMessage}</p>}
    {warningMessage && <p className="text-warning text-xs">{warningMessage}</p>}
  </div>
);
